import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const routePermissions = {
  '/nefro-admin/productos': 'products',
  '/nefro-admin/producto-agregar': 'products',
  '/nefro-admin/productos-odoo': 'products',

  '/nefro-admin/categorias-productos': 'product_data',
  '/nefro-admin/marcas-productos': 'product_data',
  '/nefro-admin/orden-productos': 'product_data',
  '/nefro-admin/comentarios-productos': 'reviews',

  '/nefro-admin/orders': 'orders',
  '/nefro-admin/pedido-abandonado': 'orders',
  '/nefro-admin/carrito-abandonado': 'orders',

  '/nefro-admin/metodos-envio': 'shipping',

  '/nefro-admin/cupones': 'coupons',
  '/nefro-admin/cupones/registrar': 'coupons',
  '/nefro-admin/promociones': 'promotions',
  '/nefro-admin/cupones-medicos': 'coupons',
  '/nefro-admin/directorio-medico': 'doctors',
  '/nefro-admin/nuevo-medico': 'doctors',
  '/nefro-admin/pedidos-medicos': 'doctors',
  '/nefro-admin/resumen-medicos': 'doctors',

  '/nefro-admin/pedidos': 'orders',
  '/nefro-admin/pedidos-incompletos': 'orders',

  '/nefro-admin/admins': 'admins',

  '/nefro-admin/banners-tienda': 'banners',

  '/nefro-admin/blog': 'blog',
  '/nefro-admin/nuevo-blog': 'blog',

  '/nefro-admin/contacto': 'contact',
  '/nefro-admin/clientes': 'clients'
};

export const ProtectedRoute = ({ children }) => {
  const { pathname } = useLocation();
  const { loggedUser } = useSelector(state => state.user);
  const { email, privileges } = loggedUser;

  if (!email || !privileges) return <Navigate to="/" />;

  // ruta principal de admin
  if (pathname === '/nefro-admin') return children;

  const requiredPrivilege = routePermissions[pathname]
    || (pathname.startsWith('/nefro-admin/clientes/') ? 'clients' : undefined);

  if (!requiredPrivilege) return children; // ruta no protegida

  // verifir que el usuario tenga el privilegio necesario
  return privileges?.[requiredPrivilege]
    ? children
    : <Navigate to="/nefro-admin" />;
};
